export const environment = {
  production: false,
  API_URL: 'https://application-test.avanacapital.com',
  RADAR_API_KEY: 'prj_test_pk_f17f404b5aa998115bbc14116b36d1ab4e614ca8'
};